import { html } from 'lit';

export const keepPinIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="m6.7 16-5.4 5.3a1 1 0 1 0 1.4 1.4l5.4-5.4L6.7 16zM23.7 7.3l-7-7a1 1 0 0 0-1.4 1.4l.9 1-11 6-1.5-1.4a1 1 0 1 0-1.4 1.4l13 13a1 1 0 0 0 1.4 0c.4-.4.4-1 0-1.4l-1.5-1.5 6.2-11 .9 1a1 1 0 0 0 1.4 0c.4-.5.4-1.1 0-1.5z"
    />
  </svg>
`;
